<div class="p-2">
  <a routerLink="../" class="text-blue-500 text-xl pl-2 pt-1"><- Back</a>
  <div class="p-2 flex flex-col justify-between" *ngIf="statsRequestData$ | async as statsRequestData">
    <div class="flex flex-col md:flex-row gap-1">
      <mat-form-field>
        <mat-label>Region</mat-label>
        <mat-select [value]="statsRequestData.lohiRegionId" (selectionChange)="setRegion($event.value)">
          <mat-option
            *ngFor="let region of (regions$ | async)?.regions; trackBy: 'id' | trackByKey"
            [value]="region.id"
          >
            {{ region.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class>
        <mat-label>Region</mat-label>
        <mat-select [value]="statsRequestData.daysOfHistory" (selectionChange)="setDaysOfHistory($event.value)">
          <mat-option [value]="1">1 Day</mat-option>
          <mat-option [value]="3">3 Days</mat-option>
          <mat-option [value]="7">1 Week</mat-option>
          <mat-option [value]="14">2 Weeks</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <table class="w-full block lg:table border border-collapse border-gray-400 table-fixed overflow-x-auto">
      <thead>
        <tr>
          <th class="border border-gray-400">Demand / Supply Ratio</th>
          <th class="border border-gray-400">Count</th>
          <th
            class="border border-gray-400 cursor-pointer"
            (click)="selectColumn('pendingOrdersAtInsertion')"
            [class.bg-blue-500]="statsRequestData.columnName === 'pendingOrdersAtInsertion'"
          >
            Pending
          </th>
          <th
            class="border border-gray-400 cursor-pointer"
            (click)="selectColumn('urgentPendingOrdersAtInsertion')"
            [class.bg-blue-500]="statsRequestData.columnName === 'urgentPendingOrdersAtInsertion'"
          >
            Urgent
          </th>
          <th
            class="border border-gray-400 cursor-pointer"
            (click)="selectColumn('deadheadLinehaulRatio')"
            [class.bg-blue-500]="statsRequestData.columnName === 'deadheadLinehaulRatio'"
          >
            Deadhead / Linehaul Ratio
          </th>
          <th
            class="border border-gray-400 cursor-pointer"
            (click)="selectColumn('correctedDeadheadLinehaulRatio')"
            [class.bg-blue-500]="statsRequestData.columnName === 'correctedDeadheadLinehaulRatio'"
          >
            Corrected Deadhead / Linehaul Ratio
          </th>
          <th
            class="border border-gray-400 cursor-pointer"
            (click)="selectColumn('stdDevMappedDeadHeadMiles')"
            [class.bg-blue-500]="statsRequestData.columnName === 'stdDevMappedDeadHeadMiles'"
          >
            Deadhead SD
          </th>
          <th
            class="border border-gray-400 cursor-pointer"
            (click)="selectColumn('stdDevMappedCorrectedDeadHeadMiles')"
            [class.bg-blue-500]="statsRequestData.columnName === 'stdDevMappedCorrectedDeadHeadMiles'"
          >
            Corrected Deadhead SD
          </th>
          <th
            class="border border-gray-400 cursor-pointer"
            (click)="selectColumn('meanMinutesToFirstDispatchInShift')"
            [class.bg-blue-500]="statsRequestData.columnName === 'meanMinutesToFirstDispatchInShift'"
          >
            Minutes To 1st Dispatch
          </th>
          <th
            class="border border-gray-400 cursor-pointer"
            (click)="selectColumn('stdDevMinutesToFirstDispatchInShift')"
            [class.bg-blue-500]="statsRequestData.columnName === 'stdDevMinutesToFirstDispatchInShift'"
          >
            Minutes To 1st Dispatch SD
          </th>
          <th
            class="border border-gray-400 cursor-pointer"
            (click)="selectColumn('outlierShifts')"
            [class.bg-blue-500]="statsRequestData.columnName === 'outlierShifts'"
          >
            Outlier Shifts
          </th>
          <th
            class="border border-gray-400 cursor-pointer"
            (click)="selectColumn('shiftsNeverDispatched')"
            [class.bg-blue-500]="statsRequestData.columnName === 'shiftsNeverDispatched'"
          >
            Never Dispatched
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of statsTable$ | async; trackBy: 'supplyDemandRatio' | trackByKey">
          <td class="border border-gray-400">{{ row.demandSupplyRatio | number: '1.0-2' }}</td>
          <td class="border border-gray-400">{{ row.ordersCreatedForLoHi | number: '1.0-2' }}</td>
          <td class="border border-gray-400">{{ row.pendingOrdersAtInsertion | number: '1.0-2' }}</td>
          <td class="border border-gray-400">{{ row.urgentPendingOrdersAtInsertion | number: '1.0-2' }}</td>
          <td class="border border-gray-400">{{ row.deadheadLinehaulRatio | number: '1.0-2' }}</td>
          <td class="border border-gray-400">{{ row.correctedDeadheadLinehaulRatio | number: '1.0-2' }}</td>
          <td class="border border-gray-400">{{ row.stdDevMappedDeadHeadMiles | number: '1.0-2' }}</td>
          <td class="border border-gray-400">{{ row.stdDevMappedCorrectedDeadHeadMiles | number: '1.0-2' }}</td>
          <td class="border border-gray-400">{{ row.meanMinutesToFirstDispatchInShift | number: '1.0-2' }}</td>
          <td class="border border-gray-400">{{ row.stdDevMinutesToFirstDispatchInShift | number: '1.0-2' }}</td>
          <td class="border border-gray-400">{{ row.outlierShifts | number: '1.0-2' }}</td>
          <td class="border border-gray-400">{{ row.shiftsNeverDispatched | number: '1.0-2' }}</td>
        </tr>
      </tbody>
    </table>
    <div *ngIf="statsGraph$ | async" class="mt-2">
      <div class="text-xl font-bold text-center">{{ (statsRequestData$ | async)?.columnName }}</div>
      <div [chart]="chart"></div>
    </div>
  </div>
</div>
